// import * as types from '../mutation-types'

export const state = {
  items: []
}

export const mutations = {
  LOAD_PRODUCTS (state, products) {
    state.items = products
    // console.log('logproducts!')
    // console.log(products)
  },

  ADD_TO_CART (state, productId) {
    state.items
      .find(product => product.id === productId)
      .inventory--
  },

  REMOVE_FROM_CART (state, removedProduct) {
    state.items
      .find(product => product.id === removedProduct.id)
      .inventory += removedProduct.quantity
  }
}
export const getters = {
  products: state => {
    // console.log('state in products:')
    // console.log(state)
    return state.items
  }
}

// export default {
//   state,
//   mutations
// }
